import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  UiAvatarComponent,
  UiBottomSheetComponent,
  UiSearchComponent,
  UiSheetEmptyStateComponent,
} from '@ui';
import { OrganizationModels } from '@share-models';
import { AuthService } from '../../../../services/auth.service';
import { BackCloseDirective } from '../../../../directives/back-close.directive';

@Component({
  selector: 'app-mobile-org-selector',
  standalone: true,
  imports: [
    FormsModule,
    TranslatePipe,
    UiAvatarComponent,
    UiSearchComponent,
    UiSheetEmptyStateComponent,
    UiBottomSheetComponent,
    BackCloseDirective,
  ],
  templateUrl: './mobile-org-selector.component.html',
  styleUrl: './mobile-org-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileOrgSelectorComponent {
  public readonly isOpen = input.required<boolean>();
  public readonly activeOrganization =
    input<OrganizationModels.OrganizationDocument | null>(null);
  public readonly userOrganizations =
    input.required<OrganizationModels.UserOrganizationDropDown[]>();

  public readonly closed = output<void>();

  private readonly authService = inject(AuthService);

  public readonly searchQuery = signal<string>('');

  public readonly filteredOrganizations = computed<
    OrganizationModels.UserOrganizationDropDown[]
  >(() => {
    const query = this.searchQuery().trim().toLowerCase();
    const activeId = this.activeOrganization()?._id?.toString();
    const withoutCurrent = this.userOrganizations().filter(
      (org) => org.id !== activeId,
    );

    if (!query) {
      return withoutCurrent;
    }

    return withoutCurrent.filter((org) =>
      org.name.toLowerCase().includes(query),
    );
  });

  public onClose(): void {
    this.closed.emit();
  }

  public async onSelectOrganization(
    org: OrganizationModels.UserOrganizationDropDown,
  ): Promise<void> {
    this.closed.emit();
    await this.authService.switchTenant(org.id);
  }
}
